'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PRESS_EVENT_TIMER_NAME = exports.PRESS_EVENT_TIMER_NAME = 'pressEvent';
var MOUSE_EMULATION_GUARD_TIMER_NAME = exports.MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
var SET_ACTIVATION_TIMER_NAME = exports.SET_ACTIVATION_TIMER_NAME = 'setHovering';
var UNSET_ACTIVATION_TIMER_NAME = exports.UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';


//////////////////
// WEBPACK FOOTER
// ./~/react-cursor-position/dist/constants.js
// module id = 426
// module chunks = 35783957827783